module.exports = "images/doc-activity-add-3.15b427df6547cf4b632e0d1807e75cd1.png";